import { render } from "./BaseContainer.vue?vue&type=template&id=2a9e303a&scoped=true&ts=true"
import script from "./BaseContainer.vue?vue&type=script&lang=ts"
export * from "./BaseContainer.vue?vue&type=script&lang=ts"

import "./BaseContainer.vue?vue&type=style&index=0&id=2a9e303a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9e303a"]])

export default __exports__